import { useCallback, useMemo } from 'react';
import { getContext } from '@picsart/miniapps-sdk';

import { BATCH_MINIAPP_ID } from 'pages/Batch/configs';
import useMemoSelector from 'hooks/useMemoSelector';
import useAuthInfo from 'hooks/useAuthInfo';
import { PUBLISH_EVENT } from 'configs/constants';
import analytics from 'pages/Batch/utils/analytics';
import { getAppliedPremiumTools } from 'store/batch/selectors';

type UseSubscribeReturnType = {
  subscribe: () => Promise<void>;
  shouldSubscribe: boolean;
}

const useSubscribe = (): UseSubscribeReturnType => {
  const appliedPremiumTools = useMemoSelector(getAppliedPremiumTools);
  const { isAuthorized, isProOrGoldUser } = useAuthInfo();

  const shouldSubscribe = useMemo(() => {
    if (!isAuthorized) return true;

    return appliedPremiumTools.length ? !isProOrGoldUser : false;
  }, [isAuthorized, appliedPremiumTools.length, isProOrGoldUser]);

  const subscribe = useCallback(async () => {
    if (shouldSubscribe) {
      const event = isAuthorized ? PUBLISH_EVENT.OFFER : PUBLISH_EVENT.REGISTRATION;
      await getContext()
        .handlers
        .publishEvent({
          event,
          data: {
            source: BATCH_MINIAPP_ID,
            is_pro_touchpoint: true,
            action: 'click',
            new_tool_names: {
              setting: {
                type: appliedPremiumTools.join(', '),
              },
            },
            touchpoint: 'batch',
            screen_id: 'batch',
            forceTier: 'pro',
          },
        });
    }
    isAuthorized ? analytics.subscriptionOfferOpen() : analytics.registrationOpen();
  }, [isAuthorized, shouldSubscribe, appliedPremiumTools]);

  return {
    shouldSubscribe,
    subscribe,
  };
};

export default useSubscribe;
